import { Colorful } from '@uiw/react-color';
import { TextInput } from '@tremor/react';
import { ChangeEventHandler, Dispatch, ReactElement, SetStateAction, useState } from 'react';
import { removeHashtag } from '../(dashboards)/tenant-settings/utils';
import { DASH, HASHTAG } from '../commons/constants/constants';
interface ColorInputProps {
  key: string;
  id: string;
  title: string;
  isReadOnly: boolean;
  colorError?: string;
  color: string;
  setColor?: Dispatch<SetStateAction<TenantTheme>>;
  changeEvent?: ChangeEventHandler<HTMLInputElement>;
}
const ColorInput = ({
  key,
  title,
  isReadOnly,
  color,
  colorError,
  id,
  setColor = () => {},
  changeEvent = () => {}
}: ColorInputProps): ReactElement => {
  const [showError, setShowError] = useState(false);
  const [showPicker, setShowPicker] = useState(false);
  const handleMouseEnter = (): void => {
    if (colorError) setShowError(true);
  };
  const handleMouseLeave = (): void => {
    setShowError(false);
  };
  const handleInputFocus = (): void => {
    setShowPicker(!showPicker);
  };
  const handlePickerChange = (newColor: {
    hex: string;
  }) => {
    const hexValue = newColor.hex;
    setColor(prevTheme => ({
      ...prevTheme,
      [id]: hexValue
    }));
  };
  return <div key={key} className='relative w-full' data-sentry-component="ColorInput" data-sentry-source-file="ColorInput.tsx">
      <p>{title || DASH}</p>
      <div className='flex mb-2 w-full'>
        <div className='w-14 h-10 border border-gray-300 mr-3 rounded' style={{
        backgroundColor: color ? `${color}` : 'white'
      }}></div>
        <div className='flex w-10 h-10 border border-gray-300 rounded-l-md items-center justify-center bg-gray-200 text-gray-500'>
          {HASHTAG}
        </div>
        <div className='flex-1' onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
          <TextInput id={id} error={colorError && !isReadOnly ? true : false} errorMessage={showError && !isReadOnly ? colorError : ''} value={removeHashtag(color)} onChange={changeEvent} className='custom-text-input h-10 rounded-l-none' readOnly={isReadOnly} onFocus={handleInputFocus} onBlur={handleInputFocus} data-sentry-element="TextInput" data-sentry-source-file="ColorInput.tsx" />
        </div>
        {!isReadOnly && showPicker && <div className='absolute right-0 top-0'>
            <Colorful disableAlpha={true} color={color} onChange={handlePickerChange} style={{
          zIndex: 50
        }} />
          </div>}
      </div>
    </div>;
};
export default ColorInput;